// videoStore.ts

const videoMap = new Map<string, HTMLVideoElement>()

export function setVideoEl(id: string, el: HTMLVideoElement) {
  videoMap.set(id, el)
}

export function getVideoEl(id: string): HTMLVideoElement | undefined {
  return videoMap.get(id)
}

export function deleteVideoEl(id: string) {
  videoMap.delete(id);
}
